
import { useEffect } from "react";

import "./It_faculties.css";

// import { Underline } from "../../widgets";

import { it_fac_profiles_used,it_dept_menu,it_sup_profiles_used } from "../../constants/it_dept";

import { Profile_display,RadialMenu } from "../../components";
import { Floatinmenu,Backtotop,Underline } from "../../widgets";
import { FaComputer } from "react-icons/fa6";
const It_faculties = () => {
  useEffect(() => {
    document.title = "ACCET-IT | Faculties";
  }, []);

  return (
    <div className="itdept">
      <div className="itbg">
        <div className="itheading">
          Department of Information Technology
        </div>

        <div className="it_sub_heading">
          Faculty members
        </div>
      </div>

      <section className="itdark">
        <div className="dept_float_menu">
          <Floatinmenu
            logo={FaComputer}
            head="Menu"
            links={it_dept_menu}
          />
        </div>

        <RadialMenu menu_links={it_dept_menu} />

        <div className="it_fac_area">
          <div className="it_teach_fac">
            <Underline heading="Teaching Faculties" />

            <Profile_display
              list_info={it_fac_profiles_used}
            />
          </div>
          <div className="it_sup_fac">
            <Underline heading="Supporting Faculties" />
            <Profile_display
              list_info={it_sup_profiles_used}
            />
          </div>
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default It_faculties;


